const SystemToast = {
  name: 'helper',
  state: {
    show: false,
    message: '',
    type: 'info',
  },
  reducers: {
    show(state, payload) {
      return {
        open: payload.open,
        message: payload.message,
        type: payload.type,
      };
    },
  },
};
export default SystemToast;
